// components/FetchInterceptor.tsx
'use client';

import { useEffect } from 'react';

export default function FetchInterceptor() {
  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const maxRetries = 1;

      for (let attempt = 1; attempt <= maxRetries + 1; attempt++) {
        try {
          const response = await originalFetch(input, init);

          if ((response.status >= 500 || response.status === 429) && attempt <= maxRetries) {
            continue;
          }

          return response;
        } catch (error) {
          if (attempt === maxRetries + 1) {
            throw error;
          }
        }
      }

      throw new Error('Unexpected retry failure');
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
}
